<div id="wrapper">
  <app-loading-screen [status]=true></app-loading-screen>
  <div class="allcont">
    <app-menu [tabActive]="this.tabActive"></app-menu>
    <div class="basicrow m-top"
      ng-if="(this.postpago && this.hasPostpago) || (this.telefoniaFijo && this.hasTelefoniaFijo)">
      <div class="container">
        <div class="basicr-line-i">
          <div class="fulltitle m-top-i f-btitle autodef">
            <span class="icon-dash-14"></span> Resumen de Factura
          </div>

        </div>
        <div class="autorow subsc pull-left m-top mob-wid">
          <label class="label-r">Número de Cuenta:</label>

          <!-- <a class="linkdefs pull-right c-fltr visible-xs" >Limpiar filtro <i class="fa fa-trash" aria-hidden="true"></i></a> -->
          <div class="basicrow">
            <select (change)="changeBan()" [(ngModel)]="selectBan" class="sel-f"
              style="background-image:url(/assets/images/selectabarrw.png)">
              <option disabled value="">N&uacute;mero de Cuenta</option>
              <option *ngFor="let account of this.banlist" [ngValue]="account.account">{{account.account}}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="basicrow mbott m-top" id="last-div"
      ng-if="(this.postpago && this.hasPostpago) || (this.telefoniaFijo && this.hasTelefoniaFijo)">
      <div class="container">

        <div class="basicrow bordsdef f-reg f-black roboto-r m-top">
          <div class="basicrow allpads">
            <div class="basicrow">
              <div class="autorow pull-left factdef roboto-b">
                Fecha de Facturaci&oacute;n
              </div>
              <div class="autorow pull-right factdef roboto-b">
                {{this.cycleStartDateField}}
              </div>
            </div>
            <div class="basicrow m-top-ii">
              <div class="autorow pull-left factdef roboto-b">
                Fecha de Vencimiento
              </div>

              <div class="autorow pull-right factdef roboto-b">
                {{this.billDueDateField}}
              </div>
            </div>
            <div class="basicrow m-top-ii">
              <div class="autorow pull-left factdef roboto-b">
                Fecha de Corte
              </div>

              <div class="autorow pull-right factdef roboto-b">
                {{this.cycleEndDateField}}
              </div>
            </div>
            <div class="basicrow m-top">
              <div class="logline full"></div>
            </div>
            <div class="basicrow m-top">
              <div class="autorow pull-left factdef roboto-b">
                Balance Pendiente
              </div>

              <div class="autorow pull-right factdef roboto-b f-red">
                &#36;{{this.billBalanceField }}
              </div>
            </div>
          </div>
          <div class="basicrow">
            <div class="basicrow allpads topbord-i">
              <div class="autorow pull-left factdef roboto-r">
                Ciclo de Facturaci&oacute;n
              </div>

              <div class="autorow pull-right factdef roboto-b">
                {{this.cycleDateField}}
              </div>
            </div>
            <div class="basicrow allpads">
              <div class="autorow pull-left factdef roboto-r">
                &Uacute;ltimo Pago
              </div>
              <div class="autorow pull-right factdef roboto-b">
                &#36;{{this.lastPaymentAmountField}}
              </div>
            </div>
          </div>
          <div class="basicrow graybg-i allpads topbord-i">
            <div class="autorow m-top-u pull-left factdef roboto-b f-big">
              Monto a Pagar
            </div>
            <div class="utorow pull-right factdef f-red roboto-m f-semi">
              <div class="basicrow rel m-top-u">
                <img matTooltipShowDelay="500" matTooltipHideDelay="500" mat-raised-button matTooltip="Ahora puedes abonar hasta $99,999.99 Si la cantidad indica CR, significa que usted tiene crédito en su cuenta."
                  class="q-t" width="100%" src="../../assets/images/tooltip1.png">
                <input [(ngModel)]="this.amountPayable2" maxlength="10"  class="inp-f billmonto" (ngModelChange)="this.checkAmount()" [appOnlycoin]>
              </div>
            </div>

          </div>
        </div>
        <div class="grid-btns">
          <div class="box-btn">
            <a (click)="this.doPayment();" class="btns red vcenter"
            [ngClass]="{'red': this.dopaymentmount,'gray':  !this.dopaymentmount}">
              <span class="tabcell">
                Paga tu Factura Aqu&iacute;
              </span>
            </a>
            <input type="hidden" id="idToken" name="idToken">
            <input type="hidden" id="idAmount" name="idAmount">
            <input type="hidden" id="idBan" name="idBan">
            <input type="hidden" id="idUrl" name="idUrl">
          </div>
          <div class="box-btn" (click)="this.global.openPDF(this.invoiceContent)">
            <a ui-sref="bills-management" class="btns blue vcenter">
              <span class="tabcell">
                Detalle de Factura
              </span>
            </a>
          </div>
          <div class="box-btn">
            <a routerLink="/paymenthistory" ui-sref="bills-payment" class="btns blue vcenter">
              <span class="tabcell">
                Hist&oacute;rico de Pagos
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>